export default __webpack_public_path__ + "static/media/blueGrid.66d458be.png";